import React from 'react'
import { AlertTriangle, RefreshCw, X } from 'lucide-react'

interface ErrorBannerProps {
  message: string
  onRetry?: () => void
  onDismiss?: () => void
  variant?: 'error' | 'warning'
  className?: string
}

export default function ErrorBanner({ 
  message, 
  onRetry, 
  onDismiss, 
  variant = 'error',
  className = '' 
}: ErrorBannerProps) {
  const baseClasses = "flex items-center justify-between p-4 rounded-lg border animate-fade-in"
  const variantClasses = variant === 'error' 
    ? "bg-red-50 border-red-200 text-red-800"
    : "bg-amber-50 border-amber-200 text-amber-800"

  return (
    <div className={`${baseClasses} ${variantClasses} ${className}`}>
      <div className="flex items-center space-x-3">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <p className="text-sm font-medium">{message}</p>
      </div>
      <div className="flex items-center space-x-2">
        {onRetry && (
          <button
            onClick={onRetry}
            className="flex items-center space-x-1 px-3 py-1 text-xs font-medium bg-white rounded-md hover:bg-gray-50 transition-colors"
          >
            <RefreshCw className="w-3 h-3" />
            <span>Retry</span>
          </button>
        )}
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="p-1 hover:bg-white rounded-md transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  )
}